'use strict';

const $body = $('body');

/**
 * init sizes of images for Photoswipe
 */
async function prepareImagesForPhotoswipe() {
    const $imagesList = $body.find('.pdp-image-carousel .pdp-image-item, .ldp-images .ldp-image-item');
    const promisesList = [];

    $imagesList.each((index, img) => {
        const promise = new Promise(function (resolve) {
            let image = new Image();

            image.src = $(img).attr('href');
            image.onload = () => {
                let w = image.width;
                let h = image.height;
                if ($(img).hasClass('pswp-wide-img')) {
                    let fullWidth = $('body').width();
                    h = (image.height * fullWidth) / image.width / 2;
                    w = fullWidth / 2;
                }
                img.dataset.pswpWidth = w;
                img.dataset.pswpHeight = h;
                $body.trigger('product:pswImageLoaded');
                resolve(); // Resolve the promise only if the image has been loaded
            };
        });
        promisesList.push(promise);
    });
    // Wait for all promises to be resolved
    await Promise.all(promisesList);
}

module.exports = {
    initZoomGallery: function () {
        prepareImagesForPhotoswipe();
    },
};
